// src/components/admin/AdminLekhi.js
import React, { useState } from 'react';
import AdminLekhiContent from './AdminLekhiContent';
import AdminLekhiContentNew from './AdminLekhiContentNew';
import AdminLekhiPlans from './AdminLekhiPlans';
import AdminLekhiPlansNew from './AdminLekhiPlansNew';

const SUB_TABS = [
  { id: 'content', label: 'Content' },
  { id: 'plans', label: 'Plans' }
];

export default function AdminLekhi() {
  const [activeSubTab, setActiveSubTab] = useState('content');
  const [contentMode, setContentMode] = useState('new');
  const [plansMode, setPlansMode] = useState('new');

  const handleModeChange = (mode) => {
    if (mode === contentMode) return;
    if (mode === 'old' && !window.confirm('Switch to the OLD content upload screen?')) return;
    setContentMode(mode);
  };

  const handlePlansModeChange = (mode) => {
    if (mode === plansMode) return;
    if (mode === 'old' && !window.confirm('Switch to the OLD plans screen?')) return;
    setPlansMode(mode);
  };

  const modeBtnStyle = (active) => ({
    padding: '8px 22px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 700,
    background: active ? '#6366f1' : '#fff',
    color: active ? '#fff' : '#555'
  });

  return (
    <div>
      <div style={{
        display: 'flex',
        gap: '8px',
        borderBottom: '1px solid #e9ecef',
        marginBottom: '20px',
        paddingBottom: '0'
      }}>
        {SUB_TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            style={{
              background: 'none',
              border: 'none',
              padding: '10px 20px',
              fontSize: '15px',
              fontWeight: activeSubTab === tab.id ? 700 : 500,
              color: activeSubTab === tab.id ? '#007fff' : '#666',
              cursor: 'pointer',
              borderBottom: activeSubTab === tab.id ? '3px solid #007fff' : '3px solid transparent',
              marginBottom: '-1px'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeSubTab === 'content' && (
        <>
          <div style={{
            display: 'inline-flex',
            border: '1px solid #ddd',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '16px'
          }}>
            <button style={modeBtnStyle(contentMode === 'new')} onClick={() => handleModeChange('new')}>New</button>
            <button style={modeBtnStyle(contentMode === 'old')} onClick={() => handleModeChange('old')}>Old</button>
          </div>
          {contentMode === 'new' ? <AdminLekhiContentNew /> : <AdminLekhiContent />}
        </>
      )}
      {activeSubTab === 'plans' && (
        <>
          <div style={{
            display: 'inline-flex',
            border: '1px solid #ddd',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '16px'
          }}>
            <button style={modeBtnStyle(plansMode === 'new')} onClick={() => handlePlansModeChange('new')}>New</button>
            <button style={modeBtnStyle(plansMode === 'old')} onClick={() => handlePlansModeChange('old')}>Old</button>
          </div>
          {plansMode === 'new' ? <AdminLekhiPlansNew /> : <AdminLekhiPlans />}
        </>
      )}
    </div>
  );
}